"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAdMachines = getAdMachines;
async function getAdMachines(advertisingRepo, adId, page = 1, pageSize = 10) {
    return advertisingRepo.getAdMachines(adId, page, pageSize);
}
